const formatDuration = (duration: number): string => {
	const roundedDuration = Math.floor(duration)
	const minutes = Math.floor(roundedDuration / 60)
	const seconds = (roundedDuration - minutes * 60).toString().padStart(2, '0')

	return `${minutes}:${seconds}`
}

export default formatDuration
